import * as React from "react";
import { DisinvestmentStrategyType } from "../../../../../../../Wrap/Constants/Enums/Client/DisinvestmentStrategyType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { DisinvestmentStrategyTypeArray } from "../../Resource/Contents";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { DisinvestmentStrategyTypeMap } from "../../../PortfolioDashboard/Components/ProductOverview/Constant/Content";

interface IDisinvestmentStrategySectionProps extends IProcessComponentProps {
    data: ApplyModel;
    isCreateNew: boolean;
}

interface IDisinvestmentStrategySectionState {}

export class DisinvestmentStrategySection extends ProcessComponent<
    IDisinvestmentStrategySectionProps,
    IDisinvestmentStrategySectionState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private clearData = () => {
        this.populateData(DisinvestmentStrategyType.NotSpecified);
    };

    private populateData = (model: DisinvestmentStrategyType) => {
        const { onChange } = this.props;
        onChange({
            DisinvestmentStrategy: model,
        });
    };

    public render(): JSX.Element {
        return (
            <div>
                <h2>Disinvestment strategy</h2>
                <RadiosEditor
                    cssWrapper="rg-inline"
                    options={DisinvestmentStrategyTypeArray}
                    selected={this.props.data?.DisinvestmentStrategy}
                    disabled={!this.props.isCreateNew}
                    getText={(o) => DisinvestmentStrategyTypeMap[o]}
                    onChange={(v) => {
                        if (v) {
                            this.populateData(v);
                        } else {
                            this.clearData();
                        }
                    }}
                    required="Please select"
                />
            </div>
        );
    }
}
